export default __webpack_public_path__ + "static/media/caret.23c852e8.png";